<!-- 积分商城 -->
<template>
    <div class="container">
        <div v-if="mall_value == 1" class="content">
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goDrawer"
                    >新增商城产品</Button
                >
                <Table :columns="columnsTable" :data="dataTable" border>
                    <template slot-scope="{ row }" slot="order_count">
                        <Button @click="goCount(row)">{{
                            row.order_count
                        }}</Button>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button type="primary" ghost @click="goDrawer(row)"
                                >编辑</Button
                            >
                            <Button type="error" ghost @click="goDel(1, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
            </div>
            <div class="page-container">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
        <div v-else-if="mall_value == 2">
            <div class="header">
                <Input
                    class="w300 mr24 mb24"
                    type="text"
                    v-model="storePramsOrder.keyword"
                    placeholder="搜索会员名称、手机号、兑换码"
                ></Input>
                <Select
                    class="w200 mr24 mb24"
                    v-model="storePramsOrder.keyword"
                    clearable
                    filterable
                    placeholder="所有"
                >
                    <Option
                        v-for="item in selectList"
                        :value="item.id"
                        :key="item.id"
                        >{{ item.name }}</Option
                    >
                </Select>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="ios-search"
                    >确认搜索</Button
                >
            </div>
            <div class="content">
                <Table :columns="columnsTableOrder" :data="dataTableOrder" border>
                    <template slot-scope="{ row }" slot="user_packet_count">
                        <Button>快递{{ row }}</Button>
                        <!-- <div>自提</div> -->
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <!-- <Button type="primary" ghost>已取货</Button> -->
                            <!-- <Button type="primary" ghost>已发货</Button> -->
                            <!-- <Button type="primary" ghost>配送</Button> -->
                            <Button type="primary" ghost>兑换</Button>
                            <Button type="error" ghost @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page-container">
                    <Page
                        :current="storePramsOrder.page"
                        :page-size="storePramsOrder.limit"
                        :total="totalOrder"
                        show-elevator
                        show-total
                        @on-change="pageChangeOrder"
                    />
                </div>
            </div>
        </div>
        <div v-else-if="mall_value == 3" class="content">
            <Form :model="form_data" label-position="right" :label-width="150">
                <FormItem label="banner图片：">
                    <div class="dis-flex">
                        <div class="form-upload mr12" @click="openModal(1)">
                            <Icon type="ios-add" size="44" color="#AEAEB3" />
                            <div>尺寸415px 300px</div>
                        </div>
                        <div v-if="form_data.show_logo" class="form-img">
                            <img class="wh100" :src="form_data.show_logo" />
                        </div>
                    </div>
                </FormItem>
                <div class="footer">
                    <Button>取消</Button>
                    <Button class="theme-bc ml24 theme-default-color"
                        >确定</Button
                    >
                </div>
            </Form>
        </div>
        <div v-else-if="mall_value == 4" class="content">
            <Form :model="form_data" label-position="right" :label-width="150">
                <FormItem label="积分通知: ">
                    <i-switch
                        v-model="form_data.word1"
                        size="large"
                        true-color="#FF761D "
                        :true-value="1"
                        :false-value="0"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem label="积分通知列表: ">
                    <Button>查看</Button>
                </FormItem>
                <FormItem label="积分抵扣: ">
                    <i-switch
                        v-model="form_data.word1"
                        size="large"
                        true-color="#FF761D "
                        :true-value="1"
                        :false-value="0"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                    <div class="mt24 mb24">
                        <Input
                            class="w200"
                            type="text"
                            v-model="form_data.num"
                            placeholder="请输入"
                        ></Input>
                        积分抵扣一元
                    </div>
                    <div>
                        最高抵扣当前订单的
                        <Input
                            class="w200"
                            type="text"
                            v-model="form_data.num"
                            placeholder="请输入"
                            ><span slot="append">%</span></Input
                        >
                    </div>
                </FormItem>
                <div class="footer">
                    <Button>取消</Button>
                    <Button class="theme-bc ml24 theme-default-color"
                        >确定</Button
                    >
                </div>
            </Form>
        </div>
        <!-- 新增商城产品/编辑商城产品 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="80">
            <Form :model="form_data" label-position="right" :label-width="150">
                <div class="form-title">商品详情</div>
                <FormItem label="商品名：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_data.name"
                        placeholder="请输入商品名"
                    ></Input>
                </FormItem>
                <FormItem label="排序：">
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_data.sort"
                        placeholder="请输入排序"
                    ></Input>
                </FormItem>
                <FormItem label="封面图: ">
                    <div class="dis-flex">
                        <div class="form-upload mr12" @click="openModal(1)">
                            <Icon type="ios-add" size="44" color="#AEAEB3" />
                            <div>320px*280px</div>
                        </div>
                        <div v-if="form_data.show_img" class="form-img">
                            <img class="wh100" :src="form_data.show_img" />
                            <Icon
                                class="upload-del"
                                size="20"
                                type="ios-close-circle"
                                color="#f00"
                                @click="delImg"
                            />
                        </div>
                    </div>
                </FormItem>
                <FormItem label="商品图: ">
                    <div class="dis-flex">
                        <div class="form-upload mr12" @click="openModal(2)">
                            <Icon type="ios-add" size="44" color="#AEAEB3" />
                            <div>690px*320px</div>
                        </div>
                        <div v-for="(e, i) in form_data.show_banner" :key="i">
                            <div class="upload-container">
                                <Icon
                                    class="upload-del"
                                    size="20"
                                    type="ios-close-circle"
                                    color="#f00"
                                    @click="delBanner(i)"
                                />
                                <img class="upload-img" :src="e" />
                            </div>
                        </div>
                    </div>
                </FormItem>
                <FormItem label="购买方式: ">
                    <CheckboxGroup
                        v-model="form_data.buy_type"
                        @on-change="changeBuyType"
                    >
                        <Checkbox
                            style="margin-right: 44px"
                            label="积分"
                        ></Checkbox>
                        <Checkbox label="线上支付"></Checkbox>
                    </CheckboxGroup>
                    <!-- <RadioGroup v-model="form_data.buy_type">
                        <Radio class="mr24" label="1">积分</Radio>
                        <Radio label="2">线上支付</Radio>
                    </RadioGroup> -->
                    <div
                        v-if="
                            form_data.buy_type_value.includes('1') &&
                            form_data.buy_type_value.includes('2')
                        "
                        style="
                            padding: 6px 12px;
                            width: 555px;
                            border: 1px dashed #ccc;
                        "
                    >
                        <div class="flex-center">
                            <div style="width: 66px">金额抵扣:</div>
                            <i-switch
                                v-model="form_data.amount_deduction"
                                size="large"
                                true-color="#FF761D"
                                :true-value="1"
                                :false-value="0"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </div>
                        <div
                            class="mt24 mb24 flex-center"
                            style="margin-left: 66px"
                        >
                            <Input
                                class="w200"
                                type="number"
                                v-model="form_data.amount"
                                placeholder="请输入"
                                ><span slot="append">元</span>
                            </Input>
                            <div class="ml12 mr12">等于</div>
                            <Input
                                class="w200"
                                type="number"
                                v-model="form_data.amount_points"
                                placeholder="请输入"
                                ><span slot="append">积分</span></Input
                            >
                        </div>
                        <div class="flex-center" style="margin-left: 66px">
                            <div class="mr12">最高抵扣当前订单的</div>
                            <Input
                                class="w200"
                                type="number"
                                v-model="form_data.rate"
                                placeholder="请输入"
                                ><span slot="append">%</span></Input
                            >
                        </div>
                    </div>
                </FormItem>
                <FormItem
                    v-if="form_data.buy_type_value.includes('1')"
                    label="所需积分: "
                >
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_data.points"
                        placeholder="请输入积分"
                    ></Input>
                </FormItem>
                <FormItem
                    v-if="form_data.buy_type_value.includes('2')"
                    label="所需金额: "
                >
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_data.money"
                        placeholder="请输入金额"
                    ></Input>
                </FormItem>
                <FormItem label="提取方式: ">
                    <RadioGroup v-model="form_data.pickup_type">
                        <Radio class="mr24" label="1">自提</Radio>
                        <Radio label="2">快递</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="兑换限制: ">
                    <RadioGroup v-model="form_data.ex_restrictions">
                        <Radio class="mr24" label="1">无限制</Radio>
                        <Radio class="mr24" label="2">每人只可兑换一次</Radio>
                        <Radio label="3">每人每天可兑换一次</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem label="库存启用: ">
                    <i-switch
                        v-model="form_data.able_stock"
                        size="large"
                        true-color="#FF761D "
                        :true-value="1"
                        :false-value="0"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <FormItem v-if="form_data.able_stock == 1" label="库存数量: ">
                    <Input
                        class="w300"
                        type="number"
                        v-model="form_data.stock"
                        placeholder="请输入库存数量"
                    ></Input>
                </FormItem>
                <FormItem label="商品详情: ">
                    <editor
                        style="width: 555px"
                        :edtor-con="form_data.content"
                        :index="1"
                        @getContent="getEnContent1"
                        @getContentchange="getEnContentchange1"
                    />
                </FormItem>
                <div class="footer">
                    <Button @click="cancelForm">取消</Button>
                    <Button
                        class="theme-bc ml24 theme-default-color"
                        @click="submitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </Drawer>
        <!-- 兑换明细 -->
        <Modal
            v-model="countDrawer"
            title="兑换明细"
            width="80"
            :mask-closable="false"
        >
            <Table :columns="columnCount" :data="dataCount" border>
                <template slot-scope="{ row }" slot="pay_status">
                    <div v-if="row.pay_status == 0">付款中</div>
                    <div v-if="row.pay_status == 1">发放成功</div>
                    <div v-if="row.pay_status == 2">发放失败</div>
                </template>
            </Table>
            <div class="page-container">
                <Page
                    :current="pageCount.page"
                    :page-size="pageCount.limit"
                    :total="totalCount"
                    show-elevator
                    show-total
                    @on-change="pageChangeCount"
                />
            </div>
            <div slot="footer"></div>
        </Modal>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="imgtype"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import {
    points_goods,
    assembly_wxpacket_status,
    assembly_wxpacket_delete,
    points_goods_infos,
    points_goods_save,
    assembly_wxpacket_prize,
    assembly_wxpacket_refresh,
    product_select,
    batch_select,
    agent_select,
    points_goods_sort,
    points_order,
} from "@/api/index";
import VueQr from "vue-qr";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { VueQr, pictureLibrary, editor },
    data() {
        return {
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
            },
            total: 0,
            columnsTable: [
                { type: "index", width: 60, align: "center" },
                { title: "排序", key: "sort", align: "center" },
                { title: "商品名", key: "name", align: "center" },
                {
                    title: "积分",
                    key: "points",
                    align: "center",
                },
                {
                    title: "提取方式",
                    key: "show_pickup_type",
                    align: "center",
                },
                {
                    title: "库存数量",
                    key: "stock",
                    align: "center",
                },
                {
                    title: "已兑换数量",
                    slot: "order_count",
                    align: "center",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
            storePramsOrder: {
                page: 1,
                limit: 10,
            },
            totalOrder: 0,
            columnsTableOrder: [
                { type: "index", width: 60, align: "center" },
                { title: "商品名", key: "id", align: "center" },
                {
                    title: "会员名",
                    key: "id",
                    align: "center",
                },
                {
                    title: "手机号",
                    key: "id",
                    align: "center",
                },
                {
                    title: "兑换码",
                    key: "id",
                    align: "center",
                },
                {
                    title: "状态",
                    key: "id",
                    align: "center",
                },
                {
                    title: "提取方式",
                    slot: "user_packet_count",
                    align: "center",
                },
                {
                    title: "取货时间",
                    key: "id",
                    align: "center",
                },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTableOrder: [],
            drawers: false,
            drawerTitle: "",
            form_data: {
                id: "",
                name: "",
                sort: "",
                img: "",
                banner: [],
                buy_type: [],
                points: "",
                money: "",
                pickup_type: "1",
                ex_restrictions: "1",
                able_stock: 1,
                stock: "",
                content: "",
                amount_deduction: 1,
                amount: "",
                rate: "",
                amount_points: "",
                buy_type_value: [],
                show_img: "",
                show_banner: [],
            },
            modeList: [
                { id: 1, name: "固定积分" },
                { id: 2, name: "随机积分" },
            ],
            batchList: [],
            productList: [],
            agentList: [],
            countDrawer: false,
            pageCount: {
                page: 1,
                limit: 10,
                packet_id: "",
                pay_status: -1,
            },
            totalCount: 0,
            columnCount: [
                { type: "index", width: 60, align: "center" },
                { title: "金额（元）", key: "money", align: "center" },
                { title: "兑换码", key: "qrcode_id", align: "center" },
                { title: "领取时间", key: "created_at", align: "center" },
                { title: "发放状态", slot: "pay_status", align: "center" },
            ],
            dataCount: [],
            mall_value: "1",
            selectList: [
                { id: 1, name: "所有" },
                { id: 2, name: "未兑换" },
                { id: 3, name: "已兑换" },
            ],
        };
    },
    mounted() {
        // 监听事件
        this.$bus.$on("mallValueChange", (val) => {
            this.mall_value = val;
            if(val == 1){
                this.getList();
            }else if(val == 2){
                this.getListOrder();
            }
        });
        this.getList();
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
    },
    beforeDestroy() {
        this.$bus.$off("mallValueChange");
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.form_data.show_img = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.form_data.img = param2[i];
                }
                this.$Message.destroy();
            } else if (this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.form_data.show_banner.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.form_data.banner.push(param2[i]);
                }
                this.$Message.destroy();
            }
        },
        openModal(e) {
            this.imgtype = e;
            this.switch_modal = true;
        },
        getList() {
            points_goods(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        getListOrder() {
            points_order(this.storePramsOrder)
                .then((res) => {
                    this.dataTableOrder = res.data.data;
                    this.totalOrder = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePramsOrder.page != 1) {
                        this.storePramsOrder.page--;
                        this.getListOrder();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChangeOrder(index) {
            this.storePramsOrder.page = index;
            this.getListOrder();
        },
        // 下拉
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getagentSelect() {
            agent_select()
                .then((res) => {
                    this.agentList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // Drawer
        goDrawer(row) {
            if (row.id) {
                this.drawerTitle = "编辑商城产品";
                this.getInfo(row.id);
            } else {
                this.drawerTitle = "新增商城产品";
                this.form_data.id = "";
                this.form_data.name = "";
                this.form_data.img = "";
                this.form_data.banner = [];
                this.form_data.buy_type = [];
                this.form_data.points = "";
                this.form_data.money = "";
                this.form_data.pickup_type = "1";
                this.form_data.ex_restrictions = "1";
                this.form_data.able_stock = 1;
                this.form_data.stock = "";
                this.form_data.content = "";
                this.form_data.buy_type_value = [];
                this.form_data.show_img = "";
                this.form_data.show_banner = [];
                this.getSort();
            }
            setTimeout(() => {
                this.drawers = true;
            }, 300);
        },
        getSort() {
            points_goods_sort()
                .then((res) => {
                    this.form_data.sort = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getInfo(id) {
            points_goods_infos({ id: id })
                .then((res) => {
                    this.form_data.id = res.data.id;
                    this.form_data.name = res.data.name;
                    this.form_data.sort = res.data.sort;
                    this.form_data.img = res.data.img;
                    this.form_data.banner = res.data.banner;
                    this.form_data.buy_type = res.data.buy_type;
                    this.form_data.points = res.data.points;
                    this.form_data.money = res.data.money;
                    this.form_data.pickup_type = res.data.pickup_type;
                    this.form_data.ex_restrictions = res.data.ex_restrictions;
                    this.form_data.able_stock = res.data.able_stock;
                    this.form_data.stock = res.data.stock;
                    this.form_data.content = res.data.content;
                    this.form_data.show_img = res.data.show_img;
                    this.form_data.show_banner = res.data.show_banner;
                    // this.form_data.amount_deduction = res.data.amount_deduction;
                    // this.form_data.amount = res.data.amount;
                    // this.form_data.rate = res.data.rate;
                    // this.form_data.amount_points = res.data.amount_points;
                    this.form_data.buy_type_value = this.form_data.buy_type.map(
                        (item) => {
                            if (item === "积分") return "1";
                            if (item === "线上支付") return "2";
                            return item;
                        }
                    );
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelForm() {
            this.drawers = false;
        },
        // 确定(提交表单)
        submitForm() {
            var data = {
                id: this.form_data.id,
                name: this.form_data.name,
                sort: this.form_data.sort,
                img: this.form_data.img,
                banner: this.form_data.banner,
                buy_type: this.form_data.buy_type_value,
                points: this.form_data.points,
                money: this.form_data.money,
                pickup_type: this.form_data.pickup_type,
                ex_restrictions: this.form_data.ex_restrictions,
                able_stock: this.form_data.able_stock,
                stock: this.form_data.stock,
                content: this.form_data.content,
                amount_deduction: this.form_data.amount_deduction,
                amount: this.form_data.amount,
                rate: this.form_data.rate,
                amount_points: this.form_data.amount_points,
            };
            points_goods_save(data)
                .then((res) => {
                    this.getList();
                    this.getListOrder();
                    this.drawers = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        goDel(index, row) {
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    assembly_wxpacket_delete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        changeStatus(row, e) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变状态吗？",
                onOk: () => {
                    let data = {
                        id: row.id,
                        status: e,
                    };
                    assembly_wxpacket_status(data)
                        .then((res) => {
                            this.getList();
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                },
                onCancel: () => {
                    this.getList();
                },
            });
        },
        // 积分领取记录
        getAssemblyWxpacketPrize() {
            assembly_wxpacket_prize(this.pageCount)
                .then((res) => {
                    this.dataCount = res.data.data;
                    this.totalCount = res.data.total;
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        pageChangeCount(index) {
            this.pageCount.page = index;
            this.getAssemblyWxpacketPrize();
        },
        goCount(row) {
            this.pageCount.packet_id = row.id;
            this.getAssemblyWxpacketPrize();
            this.countDrawer = true;
        },
        // 删除图片
        delImg() {
            this.form_data.show_img = "";
            this.form_data.img = "";
        },
        delBanner(i) {
            this.form_data.banner.splice(i, 1);
            this.form_data.show_banner.splice(i, 1);
        },
        changeBuyType() {
            this.form_data.buy_type_value = this.form_data.buy_type.map(
                (item) => {
                    if (item === "积分") return "1";
                    if (item === "线上支付") return "2";
                    return item;
                }
            );
        },
        // 富文本
        getEnContentchange1(detailData) {
            this.form_data.content = detailData.editorData;
        },
        getEnContent1(detailData) {
            this.form_data.content = detailData.editorData;
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.form-title {
    margin-bottom: 24px;
    color: #484e66;
    font-weight: 600;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page-container {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.footer {
    margin: 24px 0 0 0;
    text-align: right;
}
.form-upload {
    width: 100px;
    height: 100px;
    background-color: #fff;
    border: 1px dashed #9fa5bb;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}
.form-img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
    position: relative;
}
.wh100 {
    width: 100%;
    height: 100%;
    border-radius: 5px;
}
.dis-flex {
    display: flex;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.flex-center {
    display: flex;
    align-items: center;
}
.upload-container {
    position: relative;
    width: 100px;
    height: 100px;
    margin: 0 12px 12px 0;
}
.upload-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.upload-img {
    width: 100px;
    height: 100px;
    border-radius: 5px;
}
::v-deep .ivu-checkbox {
    margin-right: 24px;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* RadioGroup */
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border: 2px solid #ff761d !important;
}
::v-deep .ivu-radio-inner:after {
    background-color: #fff !important;
}
</style>